import { useState } from 'react'

import chatIcon from 'assets/icons/projectTeam/chat.svg'
import copyIcon from 'assets/icons/projectTeam/copy.svg'
import mailIcon from 'assets/icons/projectTeam/mail.svg'
import { projectTeam, ProjectTeamMember } from 'constants/BrandAssessmentConstants'

const getTeamsChatUrl = (email: string) => `https://teams.microsoft.com/l/chat/0/0?users=${encodeURIComponent(email)}`

const ProjectTeamCard = ({ member }: { member: ProjectTeamMember }) => {
  const [justCopied, setJustCopied] = useState(false)

  const handleCopyEmail = async () => {
    if (!member.email) return
    await navigator.clipboard.writeText(member.email)
    setJustCopied(true)
    window.setTimeout(() => setJustCopied(false), 1500)
  }

  return (
    <div className="project-team-card-container">
      <div className="project-team-card">
        <div className="project-team-photo-wrap">
          <img src={member.photo} alt={member.name} className="project-team-photo" />
          {member.email && (
            <div className="project-team-actions">
              <button
                type="button"
                className="project-team-action has-tooltip"
                data-tooltip={justCopied ? 'Copied!' : 'Copy address'}
                onClick={handleCopyEmail}
                aria-label="Copy email address"
              >
                <img src={copyIcon} alt="" />
              </button>
              <a
                href={getTeamsChatUrl(member.email)}
                target="_blank"
                rel="noreferrer"
                className="project-team-action has-tooltip"
                data-tooltip="Open Teams chat"
                aria-label="Open Teams chat"
              >
                <img src={chatIcon} alt="" />
              </a>
            </div>
          )}
        </div>
        <div className="project-team-info">
          <div className="project-team-name-block">
            <p className="subtitle-l project-team-name">{member.name}</p>
            <div className="project-team-divider" />
          </div>
          <div className="project-team-meta-block">
            <p className="body-xs color-neutral-100">{member.jobPosition}</p>
            {member.email && (
              <div className="project-team-email-row">
                <img src={mailIcon} alt="" className="project-team-mail-icon" />
                <a href={`mailto:${member.email}`} className="body-xs project-team-email">
                  {member.email}
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export const ProjectTeamGrid = () => (
  <div className="project-team-grid">
    {projectTeam.map(member => (
      <ProjectTeamCard key={member.name} member={member} />
    ))}
  </div>
)
